export default "/images/wishlist.svg?ae39a94fd4278bc9122513a53b2ab5a9";